import React, { useContext } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { customFrequencyUtils } from 'app-components/flux/scheduled-transactions';
import { FrequencyContext } from './state';

import { makeStyles } from 'tss-react/mui';

const { MIN_DAYS, MAX_DAYS } = customFrequencyUtils;

const useStyles = makeStyles()(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  freqDescription: {
    fontSize: 16,
    fontWeight: 500,
  },
  daySelect: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiOutlinedInput-root': {
      margin: '0px 8px',
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 16px',
      borderRadius: '12px',
    },
    '& .MuiTextField-root': {
      width: 'auto',
    },
  },
}));

const EveryXDays = () => {
  const { state, dispatch } = useContext(FrequencyContext);
  const { classes } = useStyles();

  // @ts-expect-error FIXME TS7006
  const handleChange = (e) => {
    const interval = parseInt(e.target.value, 10);
    interval && dispatch({ type: 'UPDATE_EVERY_X_INTERVAL', payload: interval });
  };

  const selected = state?.interval || 2;

  return (
    <Box id='every-x-days' className={classes.root}>
      <Box className={classes.daySelect}>
        <Typography className={classes.freqDescription}>Every</Typography>
        <TextField
          type='number'
          inputProps={{ min: MIN_DAYS, max: MAX_DAYS }}
          value={selected}
          onChange={handleChange}
          variant='outlined'
        />
        <Typography className={classes.freqDescription}>days</Typography>
      </Box>
    </Box>
  );
};

export default EveryXDays;
